import React, { useState, useEffect } from 'react';
import WooCheckoutAPI from '../../../../IPSAPI/WooCheckoutAPI'; 
import AmazonPay from '../../../Compatibility/Gateways/AmazonPay.ts'; 

const BlockExpress = ({store}) => {
  const [expressLoading, setExpressLoading] = useState(false);
  const [checkoutData, setCheckoutData] = useState(null); // State für die API-Antwort
  const [error, setError] = useState(null); // State für Fehler

    // AmazonPay-Instanz erstellen
    const amazonPayInstance = new AmazonPay();


  const getCheckoutExpress = async () => {             
    try {
      setExpressLoading(true);
    //console.log("Store out now: ",store);
      const response = await WooCheckoutAPI.getCheckoutExpress(store.getState().sidecartsettings.appSettings.base_url);
      setCheckoutData(response); // API-Antwort im State speichern
      setExpressLoading(false);
      console.log("CheckoutExpress response: ", response);
    } catch (error) {
      setExpressLoading(false);
      setError(error); // Fehler im State speichern
      console.error('Error fetching CheckoutExpress:', error);
    }
  };

  useEffect(() => {

    amazonPayInstance.load();

    getCheckoutExpress();
  }, []); // Leeres Abhängigkeitsarray bedeutet, dass es nur einmal beim Laden der Komponente aufgerufen wird.



  return (
    <div id="ips-checkoutexpress-details" className="ips-module">
        <div className="row g-3">
            <div className="col-12">
            <div id="ips-payment-express-buttons">
                    <h2>Express-Kasse</h2>

                    {expressLoading && <p>Loading...</p>} {/* Ladeanzeige */}
                    {error && <p style={{ color: 'red' }}>Error: {error.message}</p>} {/* Fehleranzeige */}
                    
                    {checkoutData && checkoutData.data && (
                        // Direktes Einfügen der HTML-Ausgabe ohne zusätzliches Element
                        <div 
                            id="ips-payment-request-buttons" 
                            style={{ position: 'relative', visibility: 'visible' }} 
                            dangerouslySetInnerHTML={{ __html: checkoutData.data.data }} 
                        />
                    )}
                </div>
            </div>
        </div>
    </div>
);
};

export default BlockExpress;